import changelogData from '~/components/Changes/changelog-testdata.json5';
import changelogDataCersei from '~/components/Changes/changelog-testdata-cersei.json5';
import * as React from 'react';
export default {
  changelogData,
  changelogDataCersei,
  React
};